import {
  globalConstants,
  globalSystemConstants,
  LanguageToggler,
} from "../../constants";
import { getLocalStorageItem } from "../../system";

const initialState = {
  direction:
    getLocalStorageItem("direction") ?? globalConstants.DEFAULT_DIRECTION,
  language: getLocalStorageItem("language") ?? globalConstants.DEFAULT_LANGUAGE,
};

const languageTogglerReducer = (state = initialState, action) => {
  switch (action.type) {
    case LanguageToggler.LANGUAGE_CHANGE:
      return {
        ...state,
        language: action.data.language,
        direction: action.data.direction,
      };
    case globalSystemConstants.SPINNER_ACTIVATE:
      return {
        ...state,
        spinnerActions: true,
      };
    case globalSystemConstants.SPINNER_DEACTIVATE:
      return {
        ...state,
        spinnerActions: false,
      };
    default:
      return state;
  }
};

export default languageTogglerReducer;
